import OptimizeObligation from "./OptimizeObligation.jpg"
import Ne from "./Ne.JPG"
import Su from "./Su2.png"
import AnElementOfBlank from "./AnElementOfBlank.jpg"
import RipplingEssence from "./RipplingEssence.JPG"


const choreographyData = [
    {
        key: 0,
        title: "Optimize Obligation (2018)",
        choreographer: "Choreographed by Kanami Nakabayashi",
        description: `This piece is about the "I have to" and "I want to" and the merging line between the two. 
            I feel that nowadays people are concentrated on things they "have to do," which is not always related to what they "want to do." 
            People sometimes confuse,  overlap and overwrite "i want to" with "i have to." 
            That "i have to" sometimes run you down and harm other people. 
            Is that really what you "have to" do? Where did "I want to" go? 
            This piece reflects on "i have to"s and hopes to break away from it to increase "I want to" in our lives.`,
        photoCred: "Photo by Bozzo Mori",
        image: OptimizeObligation,
    },
    {
        key: 1,
        title: `ね  (2018)`,
        choreographer: `Choreographed by Morin (Miyu Motegi and Kanami Nakabayashi)`,
        description: `This is your Project Description. It’s a great place to describe your Project in more detail. Add images and provide visitors with essential information about your work, including the project length, partnerships or any successful outcomes. To hook new potential clients, show how your work has provided solutions for past clients.`,
        photoCred: undefined,
        image: Ne,
    }
    ,
    {
        key: 2,
        title: `す (2018)`,
        choreographer: `Choreographed by Morin (Miyu Motegi and Kanami Nakabayashi)`,
        description: `Work selected to showcase by Ryohei Kondo @Kagurazaka Session House`,
        photoCred: undefined,
        image: Su,
    }
    ,
    {
        key: 3,
        title: `An Element of Blank (2017)`,
        choreographer: `Choreographed by Kanami Nakabayashi and Hunter Sturgis`,
        description: `Dancers: Becky Nam, Lizzy Tan, Mario Ramirez, Cassidy Oldham, Emily DiFranco. Music by Michael Zapruder Performance, "Ears, Eyes, and Feet", a choreographic showcase of the dance department's chores II sequence at the University of Texas at Austin.`,
        photoCred: undefined,
        image: AnElementOfBlank,
    }
    ,
    {
        key: 4,
        title: `Rippling Essence (2017)`,
        choreographer: `Choreography by Veronica Boccardo and Kanami Nakabayashi`,
        description: `Choreographed for SEED at The University of Texas at Austin`,
        photoCred: undefined,
        image: RipplingEssence,
    }
]

export default choreographyData;